"use strict";
/**
 * https://www.figma.com/file/NDYFGMfDaxqqY41C55RDgl/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8468%3A41666&t=a8d20mmtori6OOti-1
 */
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("../colors");
const common_1 = require("../tokens/common");
const buttonPrimary = {
    'button-primary-bg': (0, colors_1.getColorValue)('yellow.600'),
    'button-primary-bg-disabled': (0, colors_1.getColorValue)('grey.200'),
    'button-primary-bg-hover': (0, colors_1.getColorValue)('yellow.500'),
    'button-primary-borderBottom': (0, colors_1.getColorValue)('transparent'),
    'button-primary-borderBottom-disabled': (0, colors_1.getColorValue)('transparent'),
    'button-primary-borderBottom-hover': (0, colors_1.getColorValue)('transparent'),
    'button-primary-text': (0, colors_1.getColorValue)('grey.800'),
    'button-primary-text-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'button-primary-text-hover': (0, colors_1.getColorValue)('grey.800'),
};
const buttonSecondary = {
    'button-secondary-bg': (0, colors_1.getColorValue)('grey.200'),
    'button-secondary-bg-disabled': (0, colors_1.getColorValue)('grey.200'),
    'button-secondary-bg-hover': (0, colors_1.getColorValue)('grey.300'),
    'button-secondary-borderBottom': (0, colors_1.getColorValue)('transparent'),
    'button-secondary-borderBottom-disabled': (0, colors_1.getColorValue)('transparent'),
    'button-secondary-borderBottom-hover': (0, colors_1.getColorValue)('transparent'),
    'button-secondary-text': (0, colors_1.getColorValue)('grey.800'),
    'button-secondary-text-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'button-secondary-text-hover': (0, colors_1.getColorValue)('grey.800'),
};
const buttonDanger = {
    'button-danger-bg': (0, colors_1.getColorValue)('grey.200'),
    'button-danger-bg-disabled': (0, colors_1.getColorValue)('grey.200'),
    'button-danger-bg-hover': (0, colors_1.getColorValue)('grey.300'),
    'button-danger-borderBottom': (0, colors_1.getColorValue)('transparent'),
    'button-danger-borderBottom-disabled': (0, colors_1.getColorValue)('transparent'),
    'button-danger-borderBottom-hover': (0, colors_1.getColorValue)('transparent'),
    'button-danger-text': (0, common_1.getCommonTokenValue)('error'),
    'button-danger-text-disabled': (0, colors_1.getColorValue)('red.500'),
    'button-danger-text-hover': (0, common_1.getCommonTokenValue)('error'),
};
const buttonDiscreet = {
    'button-discreet-bg': (0, colors_1.getColorValue)('grey.200'),
    'button-discreet-bg-disabled': (0, colors_1.getColorValue)('grey.200'),
    'button-discreet-bg-hover': (0, colors_1.getColorValue)('grey.300'),
    'button-discreet-borderBottom': (0, colors_1.getColorValue)('transparent'),
    'button-discreet-borderBottom-disabled': (0, colors_1.getColorValue)('transparent'),
    'button-discreet-borderBottom-hover': (0, colors_1.getColorValue)('transparent'),
    'button-discreet-text': (0, colors_1.getColorValue)('grey.700'),
    'button-discreet-text-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'button-discreet-text-hover': (0, colors_1.getColorValue)('grey.700'),
};
const buttonInlinePrimary = {
    'button-inline-primary-bg': (0, colors_1.getColorValue)('transparent'),
    'button-inline-primary-bg-disabled': (0, colors_1.getColorValue)('transparent'),
    'button-inline-primary-bg-hover': (0, colors_1.getColorValue)('transparent'),
    'button-inline-primary-borderBottom': (0, colors_1.getColorValue)('yellow.600'),
    'button-inline-primary-borderBottom-disabled': (0, colors_1.getColorValue)('grey.400'),
    'button-inline-primary-borderBottom-hover': (0, colors_1.getColorValue)('yellow.600'),
    'button-inline-primary-text': (0, colors_1.getColorValue)('grey.800'),
    'button-inline-primary-text-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'button-inline-primary-text-hover': (0, colors_1.getColorValue)('grey.700'),
};
const buttonInlineSecondary = {
    'button-inline-secondary-bg': (0, colors_1.getColorValue)('transparent'),
    'button-inline-secondary-bg-disabled': (0, colors_1.getColorValue)('transparent'),
    'button-inline-secondary-bg-hover': (0, colors_1.getColorValue)('transparent'),
    'button-inline-secondary-borderBottom': (0, colors_1.getColorValue)('grey.800'),
    'button-inline-secondary-borderBottom-disabled': (0, colors_1.getColorValue)('grey.400'),
    'button-inline-secondary-borderBottom-hover': (0, colors_1.getColorValue)('grey.700'),
    'button-inline-secondary-text': (0, common_1.getCommonTokenValue)('text-primary'),
    'button-inline-secondary-text-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'button-inline-secondary-text-hover': (0, colors_1.getColorValue)('grey.700'),
};
const buttonTokens = {
    ...buttonPrimary,
    ...buttonSecondary,
    ...buttonDanger,
    ...buttonDiscreet,
    ...buttonInlinePrimary,
    ...buttonInlineSecondary,
};
exports.default = buttonTokens;
